import { FC } from 'react';
import styled from 'styled-components';
import { SessionData } from '../../services/Measurement';
import MeasurementRow from './MeasurementRow';

const Container = styled.div`
  padding: 38px 0;
  width: max(89%, 1284px);
  margin: 0 auto;
`;

const Table = styled.table(({ theme }) => {
  const { color } = theme;
  return `
    width: 100%;
    border: 1px solid ${color.grayscale[600]};
  `;
});

const TableHeader = styled.th(({ theme }) => {
  const { color } = theme;

  return `
    background-color: ${color.grayscale[700]};
    border: 1px solid ${color.grayscale[600]};
    padding: 10px;
    text-align: center;
  `;
});

export interface IMeasurementSessionsTable {
  sessions: SessionData[];
  titleMeasurement: string;
}

const MeasurementSessionsTable: FC<IMeasurementSessionsTable> = ({ sessions, titleMeasurement }) => {
  const tmpTimeBased = titleMeasurement.toLowerCase().trim();
  let isTimeBased = false;
  if (tmpTimeBased.endsWith('endurance') || tmpTimeBased.endsWith('attention')) {
    isTimeBased = true;
  }

  const measurementRow = sessions.map((session, rowIndex: number) => {
    return <MeasurementRow key={`sessionRow-${rowIndex}`} session={session} isTimeBased={isTimeBased} />;
  });

  return (
    <Container>
      <Table>
        <thead>
          <tr>
            <TableHeader>#</TableHeader>
            <TableHeader>Date</TableHeader>
            <TableHeader>COGNITIVE Assist.</TableHeader>
            <TableHeader>PHYSICAL Assist.</TableHeader>
            <TableHeader>Resistance</TableHeader>
            <TableHeader>Standing Tolerance</TableHeader>
            <TableHeader>{titleMeasurement}</TableHeader>
            <TableHeader>Notes</TableHeader>
          </tr>
        </thead>

        <tbody>{measurementRow}</tbody>
      </Table>
    </Container>
  );
};

export default MeasurementSessionsTable;
